'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // via https://github.com/ianstormtaylor/slate/blob/master/examples/tables/index.js


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TablePlugin = function TablePlugin() {
  return {
    renderNode: function renderNode(nodeProps) {
      var attributes = nodeProps.attributes,
          node = nodeProps.node,
          children = nodeProps.children,
          editor = nodeProps.editor;


      if (node.type === 'table') {
        var isTableBeingEdited = !!node.getDescendant(editor.state.value.anchorBlock.key);
        return _react2.default.createElement(
          'table',
          _extends({ className: (isTableBeingEdited ? 'table_active' : '') + ' ' + node.data.get('className') }, attributes),
          _react2.default.createElement(
            'tbody',
            null,
            children
          )
        );
      } else if (node.type === 'table_row') {
        return _react2.default.createElement(
          'tr',
          attributes,
          children
        );
      } else if (node.type === 'table_header') {
        return _react2.default.createElement(
          'th',
          attributes,
          children
        );
      } else if (node.type === 'table_cell') {
        var tag = node.data.get('header') ? 'th' : 'td';
        var align = node.data.get('align');
        var className = align ? 'align_' + align : null;

        return _react2.default.createElement(tag, Object.assign({ className: className }, attributes), children);
      }
      return null;
    }
  };
};

exports.default = TablePlugin;